@let dragEnabled = canEdit() && editMode();
@let dragActive = dragEnabled && dragged();

<div class="d-flex align-items-center justify-content-between mt-10 pt-8 pb-18 border-b-solid-1 bc-grey-1 mb-18 
            side-panel-filters__header-wrapper">
  <div class="side-panel-filters__header user-select-none">
    <i class="fas fa-filter i-16 mr-8"></i>
    @if (loading()) {
      <loading-rect size="75px 21px" class="d-inline-block"></loading-rect>
    }
    @else {
      <span class="fs-18">Filters ({{filters().length}})</span>
    }
  </div>
  <div class="side-panel-filters__buttons">
    @if (canEdit()) {
      @if (editMode()) {
        <button trgButton color="white" title="Add Filter" class="side-filter-rect-btn"
                (click)="addFilter()"
                [disabled]="busy()">
          <i class="fas fa-plus i-12"></i>
        </button>
        <button trgButton color="white" title="Clear" class="side-filter-rect-btn ml-8"
                (click)="clearFiltersClick()"
                [disabled]="busy()">
          <i class="far fa-trash-alt i-12"></i>
        </button>
      }
      @else {
        <button trgButton color="white" title="Reset Filters" class="side-filter-rect-btn"
                (click)="resetFiltersClick()"
                [disabled]="busy()">
          <i class="far fa-sync-alt i-12"></i>
        </button>
        <button trgButton color="white" title="Edit Filters" class="side-filter-rect-btn ml-8"
                (click)="editFiltersClick()"
                [disabled]="busy()">
          <i class="fal fa-pencil-alt i-12"></i>
        </button>
      }
    }
  </div>
</div>
<div class="d-flex side-panel-filters__filters" style="flex-direction: column;">
  @if (showResetPrompt()) {
    <div class="side-panel-filter-reset-prompt">
      <div class="backdrop" (click)="resetFilters(false, $event)">
        <div class="dialog">
          <div class="text">
            <span>Reset <strong>All</strong> Filters?</span>
          </div>
          <div class="buttons">
            <button trgButton color="outline" (click)="resetFilters(false, $event)">
              <span>Cancel</span>
            </button>
            <button trgButton color="primary" (click)="resetFilters(true, $event)">
              <span>Reset</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showDeletePrompt()) {
    <div class="side-panel-filter-reset-prompt">
      <div class="backdrop" (click)="showDeletePrompt.set(false)">
        <div class="dialog">
          <div class="text">
            <span>Delete <strong>All</strong> Filters?</span>
          </div>
          <div class="buttons">
            <button trgButton color="outline" (click)="showDeletePrompt.set(false)">
              <span>Cancel</span>
            </button>
            <button trgButton color="red-2" (click)="clearFilters()">
              <span>Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (loading()) {
    <loading-rect size="100% 30px" class="mb-10"></loading-rect>
    <loading-rect size="100% 30px" class="mb-10"></loading-rect>
  }
  @else {
    @for (f of filters(); track f.id) {
      @if (dragActive && dragged() != f) {
        <div class="side-panel-filter-drop"
             [class.first]="$first"
             [class.dropping]="drop() == dropBefore"
             trgDrop
             [dropTags]="dropTags()"
             [dropExpand]="[20, 20]"
             (trgDropEnter)="onDropEnter(dropBefore, $event.data, $index)"
             (trgDropExit)="onDropExit(dropBefore, $event.data, $index)"
             (trgDropped)="onDropFilter($event.data, $index)"
             #dropBefore>
          <ng-container *ngTemplateOutlet="
                        filterTemplate; 
                        context: { filter: dragged(), preview: true }"></ng-container>
        </div>
      }

      <ng-container *ngTemplateOutlet="
                    filterTemplate; 
                    context: { filter: f, preview: false }"></ng-container>

      @if (dragActive && $last && dragged() != f) {
        <div class="side-panel-filter-drop last"
             [class.dropping]="drop() == dropAfter"
             trgDrop
             [dropTags]="dropTags()"
             [dropExpand]="[20, 20, 20, $last ? 50 : 20]"
             (trgDropEnter)="onDropEnter(dropAfter, $event.data, $index + 1)"
             (trgDropExit)="onDropExit(dropAfter, $event.data, $index + 1)"
             (trgDropped)="onDropFilter($event.data, $index + 1)"
             #dropAfter>
          <ng-container *ngTemplateOutlet="
                        filterTemplate; 
                        context: { filter: dragged(), preview: true }"></ng-container>
        </div>
      }
    }

    @if (canEdit()) {
      <button [hidden]="filters().length"
              trgButton color="outline" title="Add Filter" class="w-100p" center
              (click)="addFilterClick()">
        <i class="fas fa-plus i-12 mr-4"></i>
        <span>Add Filter</span>
      </button>
    }
  }
</div>

<ng-template #dragPreview let-dragData="dragData">
  @let f = dragData();
  @if (f) {
    <ng-container *ngTemplateOutlet="
                  filterTemplate; 
                  context: { filter: f, preview: true }"></ng-container>
  }
</ng-template>

<ng-template #filterTemplate let-f="filter" let-preview="preview">
  <visual-editor-box #box
                     appearance="filter"
                     class="side-panel-filter-box"
                     [class.preview]="preview"
                     [class.dragging]="f.dragging()"
                     [class.dropping]="f.dragging() && drop()"
                     [class.drag-disabled]="!dragEnabled"

                     [canClose]="canEdit() && editMode()"
                     (close)="removeFilter(f)"

                     canCollapse
                     [collapsed]="f.collapsed()"
                     (collapsedChange)="f.setCollapsed($event)"

                     [class.side-panel-filter__incomplete]="f.isComplete()"
                     [class.side-panel-filter__error]="f.isValid()"
                                       
                     [dragDirective]="drag"
                     [dragHandleTitle]="true"
                     
                     trgDrag
                     #drag="TrgDragDirective"
                     [dragDisabled]="!dragEnabled"
                     [useDragHandle]="true"
                     
                     [dropTags]="dropTags()"
                     [canDrop]="!preview"
                     [dragPreview]="dragPreview"
                     [dragPreviewClass]="'ide-panel-filter-drag-preview'"
                     [dragPreviewSize]="box.hostElement.nativeElement"

                     [dragData]="f"
                     [dragDelay]="150"
                     [trgDragAxis]="'y'"
                     
                     (draggingChange)="f.onDragChange($event)"
                     >
    <span boxTitle [title]="f.longTitle()">
      <i class="fas fa-exclamation-triangle mr-6 c-white" [hidden]="f.isValid()"
         title="Error in field used by the filter"></i>
      <span>{{f.shortTitle()}}</span>
    </span>
    <div boxTitleRight>
      @if (canEdit()) {
        <trg-toggle size="small"
                    class="ml-6 p-relative ot-1"
                    [value]="!f.disabled()" 
                    (valueChange)="f.setDisabled(!$event)"> 
        </trg-toggle>
      }
    </div>
    <div>
      <filter-editor #filterEditor
                     [context]="f.visualContext()"
                     [dataSource]="visualDataSource"
                     [customFields]="[]"
                     [viewOnly]="viewMode()"
                     [groups]="f.groups()"
                     [filter]="f.filter()"
                     (filterChange)="onFilterChange(f, $event)">
        <ng-container beforeType>
          <label>Dataset</label>
          <mat-select class="trg-outline user-select-none h-24 text-ellipsis"
                      panelClass="trg-outline-dropdown min-w-200 side-panel-filters-dataset-dropdown"
                      [value]="f.schema()"
                      (valueChange)="f.setSchema($event)"
                      placeholder="Please Select">
            <mat-select-trigger>
              @let sd = f.schema();
              @if (sd) {
                <div class="d-flex align-items-center" [title]="sd.title">
                  <div class="w-20 h-20 mr-4 d-flex align-items-center">
                    @if (sd.dataset.icon) {
                      <img [src]="sd.dataset.icon.url" class="w-20 h-100p" />
                    }
                  </div>
                  <span>{{sd.title}}</span>
                </div>
              }
            </mat-select-trigger>
            @for (d of datasets(); track d.id) {
              <mat-optgroup [label]="d.title">
                @for (s of d.schemas; track s.id) {
                  <mat-option [value]="s">
                    <div class="d-flex align-items-center" [title]="s.title">
                      <div class="w-20 h-20 mr-4 d-flex align-items-center">
                        @if (d.icon) {
                          <img [src]="d.icon.url" class="w-20 h-100p" />
                        }
                      </div>
                      <span>{{s.title}}</span>
                    </div>
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </ng-container>
      </filter-editor>
    </div>
    <div boxCollapsedContent>
      <div class="side-panel-filter-desc">
        <span [innerHTML]="f.description()"></span>
      </div>
    </div>
  </visual-editor-box>
</ng-template>
